import flatten from 'lodash/flatten';
import orderBy from 'lodash/orderBy';
import pick from 'lodash/pick';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { userAgenda } from '../../../../agenda/store/agenda.selectors';
import { groupEventsByDays } from '../../../../utils/agendaUtils';
import { formatDateForUserTimezone } from '../../../../utils/date';
import { Day, ProgramConfig } from '../types/program.types';

export function useProgramAgenda(
  mode: 'agenda' | 'custom',
  defaultDays: Day[] = [],
  config?: ProgramConfig,
): Day[] {
  let days = defaultDays;
  const sessions = useSelector(userAgenda);

  if (mode === 'agenda') {
    const { days: dayKeys, eventsByDay } = groupEventsByDays(sessions);
    const tags = flatten(
      (config?.item?.tags || []).map((tag) => tag.fields.map((field) => field.field)),
    );
    days = dayKeys.map((dayKey) => {
      return {
        _id: dayKey,
        date: dayKey,
        items: (eventsByDay[dayKey] || []).map((session) => ({
          _id: session._id,
          time: session.customTime || `${formatDateForUserTimezone(session.startDate)}`,
          endTime: `${formatDateForUserTimezone(session.endDate)}`,
          title: session.title,
          subtitle: session.shortDescription,
          location: session.location,
          description: session.description,
          icon: session.icon,
          image: session.image,
          ...pick(session, tags),
        })),
      } as Day;
    });
  }
  return useMemo(
    () =>
      orderBy(
        days.filter((d) => !!d.date),
        'date',
        'asc',
      ),
    [days],
  );
}
